import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";
import { ExternalLinkWrapper } from "./ExternalLinkWrapper";

interface ExternalLinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  isTopBarLink?: boolean;
}

export const ExternalNavLink = ({
  href,
  children,
  icon,
  isTopBarLink,
  ...rest
}: ExternalLinkProps) => {
  const [backgroundColor, setBackgroundColor] = useState<string>(
    colors.transparent
  );
  const [showArrow, setShowArrow] = useState<boolean>(false);

  return (
    <ExternalLinkWrapper
      className="d-flex align-items-center justify-content-between px-4 py-3 bodyTextRegular mb-0"
      href={href}
      style={{
        backgroundColor: backgroundColor,
        textDecoration: "none",
        borderRadius: "4px",
        color: colors.textPrimary,
        gap: "8px",
        height: "fit-content",
      }}
      onMouseEnter={() => {
        setBackgroundColor(colors.ctaLight);
        setShowArrow(true);
      }}
      onMouseLeave={() => {
        setBackgroundColor(colors.transparent);
        setShowArrow(false);
      }}
      {...rest}
    >
      <div
        className="d-flex align-items-center justify-content-start mb-0"
        style={{
          gap: "8px",
          height: "fit-content",
        }}
      >
        {icon && (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "24px", width: "24px" }}
          >
            {icon}
          </div>
        )}
        <StyledText className="mb-0">{children}</StyledText>
      </div>
      {!isTopBarLink && (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            height: "24px",
            width: "24px",
            color: `${colors.textPrimary}`,
          }}
        >
          {showArrow && <FontAwesomeIcon icon={solid("arrow-right")} />}
        </div>
      )}
    </ExternalLinkWrapper>
  );
};
